// Флаг «оплата лицензий доступна» приходит с сервера в профиле пользователя и
// лежит в localStorage вместе с остальным userData. Читаем его при старте,
// чтобы карточка не мигала, а после ответа /auth/me кабинет его освежает.
const readLicensePaymentFlag = () => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData') || 'null')

    return !!(userData && userData.license_payment_enabled)
  } catch (error) {
    return false
  }
}

// Карточка «Консультационные услуги (лицензии)» на «Заказах» видна только в
// приём заявок на продление и обучение (правка Глеба 03.10.2026) — признак
// license_card_visible с /auth/me. Старое userData без него — по прежнему флагу.
const readLicenseCardFlag = () => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData') || 'null')
    if (!userData) return false
    if (userData.license_card_visible === undefined) return !!userData.license_payment_enabled

    return !!userData.license_card_visible
  } catch (error) {
    return false
  }
}

export default {
  namespaced: true,
  state: {
    shallContentShowOverlay: false,
    licensePaymentEnabled: readLicensePaymentFlag(),
    licenseCardVisible: readLicenseCardFlag(),
  },
  getters: {},
  mutations: {
    TOGGLE_CONTENT_OVERLAY(state, value) {
      state.shallContentShowOverlay = value !== undefined ? value : !state.shallContentShowOverlay
    },
    SET_LICENSE_PAYMENT_ENABLED(state, value) {
      state.licensePaymentEnabled = !!value
    },
    SET_LICENSE_CARD_VISIBLE(state, value) {
      state.licenseCardVisible = !!value
    },
  },
  actions: {},
}
